import HierarchyCardWithAreaLine from './HierarchyCardWithAreaLine'

export default HierarchyCardWithAreaLine
